import { Absent_getInstance1my5kmv368g0i as Absent_getInstance } from '../../../../../../../apollo-kotlin-apollo-api/com/apollographql/apollo/api/Optional.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import {
  toString1pkumu07cwy4m as toString,
  getStringHashCode26igk1bx568vk as getStringHashCode,
  hashCodeq5arwsb9dgti as hashCode,
  equals2au1ep9vhcato as equals,
} from '../../../../../../../kotlin-kotlin-stdlib/kotlin/js/coreRuntime.mjs';
import { initMetadataForClassbxx6q50dy2s7 as initMetadataForClass } from '../../../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
//region block: imports
var imul = Math.imul;
//endregion
//region block: pre-declaration
//endregion
var SavePlayerInputClass;
function SavePlayerInput() {
  if (SavePlayerInputClass === VOID) {
    class $ {
      constructor(partyId, playerId, name, email, badge, callSignAdjective, callSignNoun, imageURL, avatarType, unvalidatedEmails) {
        imageURL = imageURL === VOID ? Absent_getInstance() : imageURL;
        avatarType = avatarType === VOID ? Absent_getInstance() : avatarType;
        this.x6o_1 = partyId;
        this.y6o_1 = playerId;
        this.z6o_1 = name;
        this.a6p_1 = email;
        this.b6p_1 = badge;
        this.c6p_1 = callSignAdjective;
        this.d6p_1 = callSignNoun;
        this.e6p_1 = imageURL;
        this.f6p_1 = avatarType;
        this.g6p_1 = unvalidatedEmails;
      }
      toString() {
        return 'SavePlayerInput(partyId=' + this.x6o_1.toString() + ', playerId=' + this.y6o_1.toString() + ', name=' + this.z6o_1 + ', email=' + this.a6p_1 + ', badge=' + this.b6p_1.toString() + ', callSignAdjective=' + this.c6p_1 + ', callSignNoun=' + this.d6p_1 + ', imageURL=' + toString(this.e6p_1) + ', avatarType=' + toString(this.f6p_1) + ', unvalidatedEmails=' + toString(this.g6p_1) + ')';
      }
      hashCode() {
        var result = this.x6o_1.hashCode();
        result = imul(result, 31) + this.y6o_1.hashCode() | 0;
        result = imul(result, 31) + getStringHashCode(this.z6o_1) | 0;
        result = imul(result, 31) + getStringHashCode(this.a6p_1) | 0;
        result = imul(result, 31) + this.b6p_1.hashCode() | 0;
        result = imul(result, 31) + getStringHashCode(this.c6p_1) | 0;
        result = imul(result, 31) + getStringHashCode(this.d6p_1) | 0;
        result = imul(result, 31) + hashCode(this.e6p_1) | 0;
        result = imul(result, 31) + hashCode(this.f6p_1) | 0;
        result = imul(result, 31) + hashCode(this.g6p_1) | 0;
        return result;
      }
      equals(other) {
        if (this === other)
          return true;
        if (!(other instanceof SavePlayerInput()))
          return false;
        if (!this.x6o_1.equals(other.x6o_1))
          return false;
        if (!this.y6o_1.equals(other.y6o_1))
          return false;
        if (!(this.z6o_1 === other.z6o_1))
          return false;
        if (!(this.a6p_1 === other.a6p_1))
          return false;
        if (!this.b6p_1.equals(other.b6p_1))
          return false;
        if (!(this.c6p_1 === other.c6p_1))
          return false;
        if (!(this.d6p_1 === other.d6p_1))
          return false;
        if (!equals(this.e6p_1, other.e6p_1))
          return false;
        if (!equals(this.f6p_1, other.f6p_1))
          return false;
        if (!equals(this.g6p_1, other.g6p_1))
          return false;
        return true;
      }
    }
    initMetadataForClass($, 'SavePlayerInput');
    SavePlayerInputClass = $;
  }
  return SavePlayerInputClass;
}
//region block: exports
export {
  SavePlayerInput as SavePlayerInput3s7vno6nbe1ix,
};
//endregion

//# sourceMappingURL=SavePlayerInput.mjs.map
